<template>
    <div class="dark:bg-surface-800 border p-4 rounded-lg">
        <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold">{{ $t('Bank Account Selection') }}</h3>
            <div class="flex gap-2">
                <Button
                    :label="$t('New')"
                    icon="pi pi-plus"
                    size="small"
                    class="p-button-success"
                    @click="$emit('create-new')"
                />
                <Button
                    v-if="selectedBankAccount"
                    :label="$t('Edit')"
                    icon="pi pi-pencil"
                    size="small"
                    class="p-button-outlined"
                    @click="$emit('edit-bank-account')"
                />
            </div>
        </div>
        
        <div class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">{{ $t('Select Bank Account') }} <span class="text-red-500">*</span></label>
                <Dropdown
                    :modelValue="selectedBankAccount"
                    @update:modelValue="$emit('update:selectedBankAccount', $event)"
                    :options="bankAccounts"
                    optionLabel="name"
                    :placeholder="$t('Choose a bank account') + ' *'"
                    class="w-full"
                    showClear
                />
            </div>
            
            <div v-if="selectedBankAccount" class="bg-surface-50 dark:bg-surface-700 p-3 rounded">
                <h4 class="font-medium mb-2">{{ $t('Selected Bank Account Details') }}</h4>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                    <div><strong>{{ $t('Name') }}:</strong> {{ selectedBankAccount.name }}</div>
                    <div><strong>{{ $t('Bank') }}:</strong> {{ selectedBankAccount.bank_name || 'N/A' }}</div>
                    <div><strong>{{ $t('Account Number') }}:</strong> {{ selectedBankAccount.account_number || 'N/A' }}</div>
                    <div><strong>{{ $t('IBAN') }}:</strong> {{ selectedBankAccount.iban || 'N/A' }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    bankAccounts: {
        type: Array,
        default: () => []
    },
    selectedBankAccount: {
        type: Object,
        default: null
    }
});

defineEmits(['update:selectedBankAccount', 'create-new', 'edit-bank-account']);
</script>